import React, { useRef, useEffect } from 'react';

const NoAutoFillInput = ({
  type = 'text',
  value,
  onChange,
  placeholder,
  className,
  onKeyPress,
  disabled,
  maxLength,
  inputMode,
  name,
  id,
  ...props
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    const input = inputRef.current;
    if (!input) return;

    const handleFocus = () => {
      input.removeAttribute('readonly');
    };

    const handleBlur = () => {
      input.setAttribute('readonly', 'readonly');
    };

    input.addEventListener('focus', handleFocus);
    input.addEventListener('blur', handleBlur);

    return () => {
      input.removeEventListener('focus', handleFocus);
      input.removeEventListener('blur', handleBlur);
    };
  }, []);

  return (
    <input
      ref={inputRef}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      onKeyPress={onKeyPress}
      disabled={disabled}
      maxLength={maxLength}
      inputMode={inputMode}
      name={name || `input_${Math.random().toString(36).substr(2, 9)}`}
      id={id}
      readOnly
      autoComplete="new-password"
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck="false"
      data-form-type="other"
      data-lpignore="true"
      data-1p-ignore="true"
      data-bwignore="true"
      style={{ 
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        appearance: 'none'
      }}
      {...props}
    />
  );
};

const NoAutoFillTextarea = ({
  value,
  onChange,
  placeholder,
  className,
  rows,
  name,
  id,
  ...props
}) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const handleFocus = () => {
      textarea.removeAttribute('readonly');
    };

    const handleBlur = () => {
      textarea.setAttribute('readonly', 'readonly');
    };

    textarea.addEventListener('focus', handleFocus);
    textarea.addEventListener('blur', handleBlur);

    return () => {
      textarea.removeEventListener('focus', handleFocus);
      textarea.removeEventListener('blur', handleBlur);
    };
  }, []);

  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      rows={rows}
      name={name || `textarea_${Math.random().toString(36).substr(2, 9)}`}
      id={id}
      readOnly
      autoComplete="new-password"
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck="false"
      data-form-type="other"
      data-lpignore="true"
      data-1p-ignore="true"
      data-bwignore="true"
      style={{ 
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        appearance: 'none'
      }}
      {...props}
    />
  );
};

export { NoAutoFillInput, NoAutoFillTextarea };
